import {useService} from '@cindedi/react-application';
import {A} from '@cindedi/ui/components/A';
import {H2} from '@cindedi/ui/components/Heading/H2';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {withErrorHandling} from '@cindedi/request-utilities/withErrorHandling';
import {useLoaderData} from '@remix-run/react';
import {removeNonNumericCharFromString} from '~/domains/organization/components/PublicFooter';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface ContatoLoaderData {
  telephone: string;
  address: string;
}

export const meta: MetaFunction = function ContatoMeta({matches}) {
  return seoMeta('contato', {title: 'Contato - Cindedi', description: 'Entre em contato com o CINDEDI! Confira nosso endereço e telefone para esclarecer dúvidas e agendar visitas. Estamos à disposição!'}, matches);
};

export const loader: LoaderFunction = withErrorHandling(async function ContatoLoader({context: {use}}) {
  const Metadata = use('Metadata');

  const [telephone, address] = await Promise.all([
    Metadata.findOrFail({where: {key: 'telephone'}}),
    Metadata.findOrFail({where: {key: 'address'}}),
  ]);

  return json({
    telephone: telephone.value,
    address: address.value,
  });
});

export default function ContatoView() {
  const {telephone, address} = useLoaderData<ContatoLoaderData>();
  useService('organization/titlebar').setTitle('Contato');

  return (
    <PublicLayout>
      <div className="flex flex-col flex-1 gap-2 pt-4 max-w-full">
        <div className="flex flex-col gap-2 text-sm mt-1 bg-shade-1 p-4 rounded mb-4">
          <div>
            <H2>Endereço</H2>
            <div dangerouslySetInnerHTML={{__html: address}} />
          </div>
          <div>
            <H2>Telefone</H2>
            <A href={`tel:+55${removeNonNumericCharFromString(telephone)}`}>{telephone}</A>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
